import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useToolsRoutesConditions } from '@pages/Tools/ToolsRoutes'

import { ShoppingBagIcon } from '@ui/icons/ShoppingBag.icon'
import { ShoppingCartIcon } from '@ui/icons/ShoppingCart.icon'
import { ToolsIcon } from '@ui/icons/Tools.icon'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection, useWithMobileIcon } from '../useMenuSections'

export const useToolsMenu = (): MenuSection => {
  const { t } = useTranslation()
  const { isToolsVisible } = useToolsRoutesConditions()
  const withMobileIcon = useWithMobileIcon()

  return useMemo(
    () => ({
      id: 'tools',
      label: t('Tabs.Tools'),
      icon: ToolsIcon,
      condition: isToolsVisible,
      products: [TickmillProductType.ETD],
      children: [
        {
          id: 'platform-vendors',
          label: t('Platform Vendors.title'),
          path: '/dashboard/tools/platform-vendors',
          products: [TickmillProductType.ETD],
          icon: withMobileIcon(ShoppingBagIcon),
        },
        {
          id: 'market-data-vendors',
          label: t('Market Data.Market Data Vendors'),
          path: '/dashboard/tools/market-data-vendors',
          products: [TickmillProductType.ETD],
          icon: withMobileIcon(ShoppingCartIcon),
        },
      ],
    }),
    [t, isToolsVisible, withMobileIcon]
  )
}
